import getLocalString from "constants/Localization";
import { useGetYearOverYearRevenueReportExportMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

const useGetYearOverYearRevenueReportExport = () => {
  const [mutation, { loading, data, error }] = useGetYearOverYearRevenueReportExportMutation();
  const [getYearOverYearRevenueReportExport, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getYearOverYearRevenueReportExport",
    },
    {
      successMessage: getLocalString("organization.generate-report-success"),
      failureMessage: getLocalString("organization.generate-report-failure"),
    }
  );

  return [getYearOverYearRevenueReportExport, { ...context, data }] as const;
};

export default useGetYearOverYearRevenueReportExport;
